import stat from 'utils/stat';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import React from 'react';

import wxUtil from '../../utils/wx';
import RootStore from '../../store/RootStore';
import ShareToast from '../Followee/ShareToast';
import { IOneGallery } from '../GalleryList/Common';

type ImageShareProps = {
  visible: boolean;
  list: IOneGallery[];
  avatar?: string;
  rootStore?: RootStore;
  onClose: () => void;
  onComplete: () => void;
  onRestoreShare?: () => void;
};

const normalizeAvatar = (avatar = '') => {
  const decodedAvatar = decodeURIComponent(avatar);
  return decodedAvatar.startsWith('//')
    ? decodedAvatar.replace('//', 'https://')
    : decodedAvatar;
};

const ImageShare = (props: ImageShareProps) => {
  if (!props.visible) {
    return null;
  }

  const imageIds = props.list.map(item => item.id);
  const avatar = normalizeAvatar(props.avatar);

  return (
    <ShareToast
      hideSubTitle={true}
      getDefaultShare={() =>
        wxUtil.configImageShare(imageIds, avatar ? { image: avatar } : undefined)
      }
      onClose={props.onClose}
      onLinkClick={() => {
        props.rootStore!.uiStore.showToast({
          content: intl.get('Copyed'),
        });
        props.onComplete();
      }}
      onEditClick={(options?: any) => {
        wxUtil.configImageShare(imageIds, options);
        wxUtil.showShareLimitTip(() => {
          props.onRestoreShare?.();
          props.onComplete();

          if (options && options.title) {
            stat.event('share_desc', {
              title: options.title,
              desc: options.desc,
            });
          }
        });
      }}
    />
  );
};

export default inject('rootStore')(observer(ImageShare));
